var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4138_9493)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M13.6667 9.3335C14.219 9.3335 14.6667 8.88578 14.6667 8.3335C14.6667 7.78121 14.219 7.3335 13.6667 7.3335C13.1145 7.3335 12.6667 7.78121 12.6667 8.3335C12.6667 8.88578 13.1145 9.3335 13.6667 9.3335Z",
    fill: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12.5477 0.699041L2.24454 3.45978C1.88889 3.55507 1.67784 3.92063 1.77313 4.27627L2.63586 7.49603C2.73116 7.85167 3.09671 8.06273 3.45236 7.96743L13.7556 5.2067C14.1112 5.1114 14.3223 4.74584 14.227 4.3902L13.3642 1.17045C13.2689 0.814802 12.9034 0.603747 12.5477 0.699041Z",
    fill: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6666 6.22438C14.3635 6.0804 14.0245 5.99984 13.6666 5.99984C12.3779 5.99984 11.3333 7.04451 11.3333 8.33317C11.3333 9.62183 12.3779 10.6665 13.6666 10.6665C14.0245 10.6665 14.3635 10.5859 14.6666 10.442V11.9998C14.6666 12.7362 14.0696 13.3332 13.3333 13.3332H2.66659C1.93021 13.3332 1.33325 12.7362 1.33325 11.9998V3.99984C1.33325 3.26346 1.93021 2.6665 2.66659 2.6665H13.3333C14.0696 2.6665 14.6666 3.26346 14.6666 3.99984V6.22438Z",
    fill: "#8D8D8D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4138_9493"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.649c0eee32ae3400fcd30ba91b640de5.svg";
export { ForwardRef as ReactComponent };